import { match } from 'ts-pattern'
import { z } from 'zod'

export const monitorBillingPlanSchema = z
  .object({
    plan_type: z
      .enum([
        'trial',
        'free',
        'tier_one',
        'tier_two',
        'tier_three',
        'tier_four',
        'enterprise',
      ])
      .optional(),
    start_date: z.coerce.date().optional(),
    end_date: z.coerce.date().nullable().optional(),
    credits: z.number().optional(),
  })
  .transform((data) => {
    const { plan_type, start_date, end_date, ...rest } = data
    return {
      ...rest,
      startDate: start_date,
      endDate: end_date,
      planType: match(plan_type)
        .with('trial', () => 'Trial')
        .with('free', () => 'Free')
        .with('tier_one', () => 'Tier 1')
        .with('tier_two', () => 'Tier 2')
        .with('tier_three', () => 'Tier 3')
        .with('tier_four', () => 'Tier 4')
        .with('enterprise', () => 'Enterprise')
        .otherwise(() => 'Unknown'),
    }
  })
  .describe('Monitor Billing Plan')

export type MonitorBillingPlanType = z.infer<typeof monitorBillingPlanSchema>
